export const QueryKey = {
	productType: 'product-types',
	formTemplates: 'form-templates',
	forms: 'forms',
	content: 'content',
	users: 'users',
	carts: 'carts',
	shippingMethods: 'shipping-methods',
	orders: 'orders',
	projects: 'projects',
	configuratorProductDefinitions: 'configurator/product-definitions',
} as const;

export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
